<template>
  <div :class="modal_name ? 'p-0' : 'px-4 pt-5 pb-4'" class="exam-question-list col-lg-12">
    <!--col-lg-8 col-sm-12 col-xs-12 offset-lg-2-->

    <button v-if="!modal_name" class="uk-modal-close-default" type="button" uk-close @click="closeModal"></button>

    <!--Messages-->
    <div class="uk-flex">
      <div class="col-lg-6 offset-lg-3 col-12 col-sm-6 offset-sm-3">
        <div v-if="errorMessages.length" class="uk-alert-danger text-center" uk-alert>
          <template v-for="(error, index) in errorMessages">
            <span v-if="error != null" :key="index">
              <a class="uk-alert-close" uk-close></a>
              <p class="m-0" style="color: red">
                <i class="uil-exclamation-triangle"></i> {{ error }}
              </p>
            </span>
          </template>
        </div>
        <div v-if="successMessage" class="text-center" uk-alert
          :style="{ backgroundColor: isPassed ? '#62d76b' : 'red', color: 'white !important' }">
          <p>
            <i class="uil-exclamation-triangle" style="color: white !important;"></i> {{ successMessage }}
          </p>
        </div>
        <div v-if="isCompletedReview" class="completed-exam-alert text-center" uk-alert>
          <p>
            <i class="uil-info-circle"></i>
            {{ $t('exam.completed_review_info') }}
          </p>
        </div>
      </div>
    </div>

    <!-- Card Body -->
    <div class="card-body actions-toolbar border-0 p-0">

      <div class="row">
        <div id="wizard_container" class="col-md-6 offset-md-3">
          <div id="top-wizard">
            <div id="progressbar"></div>
          </div>

          <!--Exam Result -->
          <div v-show="showExamResult && exam_finished" class="exam-result">
            <div class="row text-center mb-3">
              <div class="col-lg-6 text-nowrap">
                <h4><span class="font-weight-bold">{{ $t('exam.exam_question_count') }}: </span> {{ questionCount }}
                </h4>
              </div>
              <div class="col-lg-4 text-nowrap d-none">
                <h4><span class="font-weight-bold">{{ $t('exam.exam_right_wrong_question_count') }} :</span>
                  {{ right_answer_count }} / {{ wrong_answer_count }} </h4>
              </div>
              <div class="col-lg-6 text-nowrap">
                <h4><span class="font-weight-bold">{{ $t('exam.exam_user_point') }} : </span> {{ user_point }}</h4>
              </div>
            </div>
          </div>

          <template v-for="(question, questionIndex) in questions">

            <!--Question & Options -->
            <div v-show="question.id === activeQuestion.id || exam_finished" :id="'question-' + question.id"
              :data-id="question.id" class="step">
              <span class="count">{{ exam_finished ? questionIndex + 1 : currentQuestionNumber }} / {{
                questionCount
              }}</span>
              <div v-if="exam && !exam_finished" class="exam-timer">
                <i class="uil-clock"></i>
                <count-down :deadline="deadline" @timeIsUp="timeIsUp"></count-down>
              </div>
              <div class="main_question" :class="{ 'has-media': question.media }">
                <img v-if="question.media" :src="getEnvironmentMediaUrl(question.media)" alt="Görsel"
                  class="image-preview question-image" />
                <div class="question-text" v-html="question.text"></div>
              </div>

              <!-- Pre sınav cevabı gösterimi -->
              <div v-if="isPostExam && getPreAnswerForQuestion(question)" class="pre-answer-info mb-3">
                <div class="alert">
                  <i class="uil-info-circle" />
                  {{ $t('general.pre_exam_answer') }}:
                  <strong>{{ getPreAnswerText(question) }}</strong>
                </div>
              </div>

              <hr>

              <div v-for="(option, option_index) in question.options" class="form-group">
                <label class="container_radio version_2 answer" :class="getOptionClass(question, option)">
                  <input :id="'question_' + question.id + '_answer_' + option.id" :data-id="option.id"
                    :name="'question_' + question.id" :value="option.id" class="required" type="radio"
                    :checked="isOptionChecked(question, option)"
                    @change="saveAnswer(question.id, option.id)" :disabled="isCompletedReview || exam_finished" />
                  <span class="checkmark"></span>
                  <img v-if="option.media" :src="getEnvironmentMediaUrl(option.media)" alt="Görsel"
                    class="image-preview option-image" />
                  <span class="option-text">{{ option.text }}</span>
                  <span v-if="getOptionStatusLabel(question, option)" class="answer-status">
                    {{ getOptionStatusLabel(question, option) }}
                  </span>
                </label>
              </div>

            </div>

            <div v-if="question !== null && +question.question_type_id === 1 && false" :id="'question-' + question.id"
              :key="'new_question_box_' + questionIndex" :data-id="question.id" class="form-group row mb-3">
              <h6 class="col-12">{{ questionIndex + 1 + ". " + question.text }}</h6>
              <div v-for="(option, option_index) in question.options"
                :key="'question_' + questionIndex + '_answer_box_' + option_index" class="col-12 form-control-group">
                <div class="d-inline-flex align-items-center answer">
                  <input :id="'question_' + question.id + '_answer_' + option.id" :data-id="option.id"
                    :name="questionIndex" :value="option.id" class=" form-control mb-0 mr-1 line-height-1" type="radio" />
                  <label :for="'question_' + questionIndex + '_answer_' + option_index" class="small m-0 cursor-pointer">
                    {{ option.text }}</label>
                </div>
              </div>
            </div>

            <!--        <div
                        v-if="+question.question_type_id === 2"
                        :key="'question_box_' + index"
                        class="form-group row mb-3"
                    >
                      <h6 class="col-12">{{ index + 1 + ". " + question.text }}</h6>
                      <div class="col-12">
                        <span
                            v-for="(answer, answer_index) in question.options"
                            :key="'question_' + index + '_answer_box_' + answer_index"
                            :class="answer_index != 0 ? ' ml-2' : ''"
                            class="d-inline-flex align-items-center"
                        >

                          <input :id="'question_' + index + '_answer_' + answer_index"
                                 v-model="answer.id"
                                 class="d-inline-flex mb-0 mr-1 line-height-1" type="checkbox"/>
                          <label :for="'question_' + index + '_answer_' + answer_index"
                                 class="small m-0 cursor-pointer">
                            {{ answer.text }}</label>
                        </span>
                      </div>
                    </div>-->

            <!--
                    <div
                        v-if="+question.question_type_id === 1"
                        :key="'question_box_' + index"
                        class="form-group row mb-3"
                    >
                      <h6 class="col-12">{{ index + 1 + ". " + question.text }}</h6>
                      <div class="col-12">
                        <span
                            v-for="(answer, answer_index) in question.options"
                            :key="'question_' + index + '_answer_box_' + answer_index"
                            :class="+answer_index !== 0 ? ' ml-2' : ''"
                            class="d-inline-flex align-items-center"
                        >
                          <input
                              :id="'question_' + index + '_answer_' + answer_index"
                              v-model="answer.id"
                              :name="'question_' + index + '_radio_group'"
                              class="d-inline-flex mb-0 mr-1 line-height-1"
                              type="radio"
                          />

                          <label
                              :for="'question_' + index + '_answer_' + answer_index"
                              class="small m-0 cursor-pointer"
                          >
                            {{ answer.text }}</label
                          >
                        </span>
                      </div>
                    </div>
            -->

            <!--        <div
                        v-if="+question.question_type_id === 6"
                        :key="'question_box_' + index"
                        class="form-group row mb-3"
                    >
                      <h6 class="col-12">{{ index + 1 + ". " + question.text }}</h6>
                      <div class="col-12">
                        <textarea
                            :id="'question_' + index + '_answer_' + 0"
                            v-model="answer.id"
                            :placeholder="question.question_answers[0].text"
                        />
                      </div>
                    </div>-->
          </template>


        </div>

        <!-- /Wizard container -->
      </div>
    </div>


    <div id="bottom-wizard" class="exam-buttons">
      <button v-show="!exam_finished" :disabled="activeQuestionIndex <= 0" class="btn btn-primary ml-2 mr-2" type="button"
        @click="changeQuestion(1)"> {{ $t('general.previous_pagination') }}
      </button>
      <button v-show="!exam_finished" :disabled="activeQuestionIndex >= questionCount - 1"
        class="btn btn-primary mr-2 mr-2" type="button" @click="changeQuestion(2)">{{ $t('general.next_pagination') }}
      </button>
    </div>

    <div id="bottom-wizard-submit" class="exam-buttons">
      <button v-if="!hideSubmit && activeQuestionIndex === questionCount - 1" v-show="!exam_finished"
        :disabled="disableSubmitButton" class="btn btn-info mr-2 mr-2" name="process" type="button" @click="onSubmit">
        <i v-if="disableSubmitButton" class="uil-sync exam-submit-spinner"></i>
        {{ disableSubmitButton ? $t("general.exam_result_saving") + "..." : $t("general.submit") }}
      </button>

      <button v-show="exam_finished" class="btn btn-info mr-2 mr-2" name="process" type="button" @click="closeModal">{{
        $t("general.close")
      }}
      </button>
    </div>
  </div>
</template>

<script>
import CountDown from "@/view/components/exam/CountDown";
import moment from "moment";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import { getEnvironmentMediaUrl } from "@/utils/imageHelper";

export default {
  name: "ExamQuestionList",
  components: {
    CountDown,
    DefaultLoading
  },
  props: {
    exam: {
      required: true,
    },
    modal_name: {
      required: true,
    },
    modal_title: {
      required: false,
    },
    hideSubmit: {
      required: false,
      default: false,
    },
    readOnly: {
      required: false,
      default: false,
    },
    /**
     * Hak varsa (`exam_attempts[...].can_start_exam`) daha once TAMAMLANMIS bir
     * sinav yeniden cozulebilir; `user_has_completed_exam` tek basina salt-okunur
     * inceleme moduna dusurmesin. `readOnly` yine onceliklidir.
     * Default false -> bu komponenti kullanan diger ekranlar etkilenmez.
     */
    canRetake: {
      required: false,
      default: false,
    }
  },
  data() {
    return {
      isPassedExam: null,
      userAnswers: [],
      activeQuestionIndex: 0,
      errorMessages: [],
      successMessage: null,
      right_answer_count: 0,
      wrong_answer_count: 0,
      right_answers: [],
      user_answers: [],
      user_point: 0,
      exam_finished: false,
      disableSubmitButton: false,
      preResults: []
    };
  },
  computed: {
    currentQuestionNumber() {
      return this.activeQuestionIndex + 1;
    },
    activeQuestion() {
      return this.questions && this.questions.length ? this.questions[this.activeQuestionIndex] : null;
    },
    questionCount() {
      return this.exam && this.exam.questions ? this.exam.questions.length : 0
    },
    deadline() {
      let now = moment();
      let duration = this.exam.duration || 1;
      return now.add(duration, 'minutes').unix();
    },
    questions() {
      if (!this.exam.name) return [];
      let questions = [];
      return this.exam.questions;
    },
    isPostExam() {
      return this.exam && this.exam.pre_results && this.exam.pre_results.length > 0;
    },
    isCompletedReview() {
      if (this.readOnly) return true;
      // Hak varsa tamamlanmis sinav tekrar cozulebilir -> inceleme modu degil
      if (this.canRetake) return false;
      return !!this.exam?.user_has_completed_exam;
    },
    showExamResult() {
      return this.isEnabledFlag(this.exam?.show_result);
    },
    showReviewUserAnswers() {
      return this.isEnabledFlag(this.exam?.show_user_answers);
    },
    showReviewRightAnswers() {
      return this.showReviewUserAnswers && this.isEnabledFlag(this.exam?.show_right_answers);
    }
  },
  watch: {
    exam: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.initializeCompletedReview();
        });
      }
    }
  },
  methods: {
    getEnvironmentMediaUrl,
    isEnabledFlag(value) {
      return value === true || +value === 1;
    },
    initializeCompletedReview() {
      if (!this.isCompletedReview || !this.questions.length) return;

      this.userAnswers = this.questions
        .filter((question) => this.hasUserAnswer(question))
        .map((question) => ({
          questionId: question.id,
          answerId: question.user_answer_id,
          is_correct: question.user_is_correct,
        }));

      this.right_answer_count = this.questions.filter((question) => this.isUserAnswerCorrect(question)).length;
      this.wrong_answer_count = this.questions.filter((question) => this.hasUserAnswer(question) && !this.isUserAnswerCorrect(question)).length;
      this.user_point = this.getCompletedReviewPoint();
      this.exam_finished = true;
    },
    getCompletedReviewPoint() {
      return this.exam?.user_point ?? 0;
    },
    hasUserAnswer(question) {
      return question?.user_answer_id !== undefined && question?.user_answer_id !== null;
    },
    isUserAnswerCorrect(question) {
      return question?.user_is_correct === true || +question?.user_is_correct === 1;
    },
    isOptionChecked(question, option) {
      if (this.isCompletedReview) {
        if (!this.showReviewUserAnswers) return false;
        return this.hasUserAnswer(question) && +question.user_answer_id === +option.id;
      }

      return this.userAnswers.some((item) => +item.questionId === +question.id && +item.answerId === +option.id);
    },
    isCorrectOption(option) {
      return option?.is_correct === true
        || +option?.is_correct === 1
        || option?.is_right === true
        || +option?.is_right === 1
        || option?.correct === true
        || +option?.correct === 1;
    },
    getOptionClass(question, option) {
      if (!this.isCompletedReview) return {};
      if (!this.showReviewUserAnswers) return { 'answer--readonly': true };

      const isSelected = this.isOptionChecked(question, option);
      const isCorrectOption = this.isCorrectOption(option);

      if (!this.showReviewRightAnswers) {
        return {
          'answer--selected': isSelected,
          'answer--readonly': true,
        };
      }

      return {
        'answer--selected': isSelected,
        'answer--correct': (isSelected && this.isUserAnswerCorrect(question)) || (!isSelected && isCorrectOption),
        'answer--wrong': isSelected && this.hasUserAnswer(question) && !this.isUserAnswerCorrect(question),
        'answer--readonly': true,
      };
    },
    getOptionStatusLabel(question, option) {
      if (!this.isCompletedReview) return '';
      if (!this.showReviewUserAnswers || !this.showReviewRightAnswers) return '';

      const isSelected = this.isOptionChecked(question, option);
      if (isSelected && question.user_is_correct !== undefined && question.user_is_correct !== null) {
        return this.isUserAnswerCorrect(question) ? this.$t('general.correct') : this.$t('general.wrong');
      }

      if (!isSelected && this.isCorrectOption(option)) {
        return this.$t('general.correct_answer');
      }

      return '';
    },
    saveAnswer(questionId, answerId) {
      if (this.isCompletedReview) return;

      this.userAnswers = this.userAnswers.filter((item) => +item.questionId !== +questionId);
      this.userAnswers.push({
        questionId: questionId,
        answerId: answerId,
      });
    },

    changeQuestion(type = 1) {
      this.errorMessages = [];

      if (+type === 2) {
        const hasAnswer = this.userAnswers.some(
          (item) => +item.questionId === +this.activeQuestion.id
        );

        if (!hasAnswer) {
          this.errorMessages.push(this.$t("question.question_required"));
        } else {
          this.activeQuestionIndex++;
        }
      } else if (+type === 1) {
        if (this.activeQuestionIndex < 1) {
          this.activeQuestionIndex = 0;
        } else {
          this.activeQuestionIndex--;
        }
      }
    },
    showUserAnswers() {
      if (this.userAnswers && this.userAnswers.length) {

        this.userAnswers.forEach((user_answer) => {
          let userAnswer = $("#question_" + user_answer.questionId + '_answer_' + user_answer.answerId);
          // if (user_answer.is_correct) {
          //   userAnswer.parent().addClass("text-success");
          // } else {
          // userAnswer.parent().addClass("text-danger");

          // userAnswer.parent().addClass("checked");
          userAnswer.prop("checked", true);
          // }
        })
      }
    },
    showRightAnswers() {
      if (this.right_answers && this.right_answers.length) {
        this.right_answers.forEach((right_answer, index) => {
          let rightAnswer = $("#question_" + right_answer.id + '_answer_' + right_answer.answerId);
          rightAnswer.parent().addClass("text-success");
        })
      }
    },
    timeIsUp(value) {
      if (value) {
        this.disableSubmitButton = true;
        this.onSubmit();
      }
    },
    onSubmit() {
      if (this.isCompletedReview) return;

      this.resetMessages();

      // Tüm sorular cevaplanmış mı kontrolu
      if (+this.questionCount !== +this.userAnswers.length) {
        this.errorMessages.push(this.$t("exam.answer_all_questions"));
        return;
      }

      this.disableSubmitButton = true;

      this.$emit("onSubmit", { results: this.userAnswers }, (data) => {
        this.disableSubmitButton = false;

        if (data.status) {
          // Sonuç kaydedildi. Sınavdan BASARISIZ olmak da buraya düşer:
          // backend 200 + has_error ile kaydediyor, kaydetme hatası değil.
          this.exam_finished = true;
          this.handleExamSuccess(data);
          return;
        }

        // Sonuç KAYDEDILMEDI (örn. 422 hak bitti / atama süresi). Sınavı
        // bitmiş göstermiyoruz: sonuç ekranına düşmesin, hak tüketilmedi.
        this.handleExamFailure(data);
      });
    },

    handleExamFailure(data) {
      // Not: Sınav başarısız olduğuda doğru cevaplar gosterilmeyecek

      const errorMessage = data.error?.message;

      if (errorMessage?.message) {
        this.errorMessages.push(this.$t("exam." + errorMessage.message));
      }

      // Not: sınvı daha onceden aktılmışssa show_result verisi olmayacak
      const userPoint = errorMessage?.user_point;
      if (userPoint !== undefined && (this.exam.show_result || this.exam.show_result === 1)) {
        this.user_point = userPoint;
      }
    },

    handleExamSuccess(data) {
      const responseData = data.data;

      if (responseData?.message) {
        this.successMessage = this.$t('exam.' + responseData.message);
      }

      const userPoint = responseData?.user_point || responseData?.user_result?.user_point;
      if (userPoint !== undefined && (this.exam.show_result || this.exam.show_result === 1)) {
        this.user_point = userPoint;
      }

      // sınav geçilirse
      this.isPassed = userPoint >= this.exam.passmark;

      if (this.isPassed) {
        if (this.exam.show_right_answers || this.exam.show_right_answers === 1) {
          this.right_answers = responseData?.right_answers;
          if (this.right_answers) {
            this.showRightAnswers();
          }
        }

        if (this.exam.show_user_answers || this.exam.show_user_answers === 1) {
          this.showUserAnswers();
        }
      }
    },
    showErrors(errors) {
      this.resetMessages();
      for (const [field, error] of Object.entries(errors)) {
        if (Array.isArray(error)) {
          error.forEach((text) => {
            this.errorMessages.push(text);
          });
        } else this.errorMessages.push(error);
      }
    },
    closeModal() {
      this.$emit('onClose', true);
      if (this.modal_name) this.$modal.hide(this.modal_name);
    },
    resetMessages() {
      this.errorMessages = [];
    },
    getPreAnswerForQuestion(question) {
      if (!this.isPostExam) return null;
      return this.exam.pre_results.find(result => result.exam_question_id === question.parent_id);
    },
    getPreAnswerText(question) {
      const preAnswer = this.getPreAnswerForQuestion(question);
      if (!preAnswer) return '';

      const option = question.options.find(opt => opt.parent_id === preAnswer.exam_question_option_id);
      return option ? option.text : '';
    },

  }
};
</script>
<style scoped>
.text-success {
  background-color: #90ec53 !important;
}

.text-danger {
  background-color: red !important;
}

.line-height-1 {
  line-height: 1rem;
}


body {
  background: #fff;
  font-size: .875rem;
  line-height: 1.4;
  font-family: "Work Sans", Arial, sans-serif;
  color: #555
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: #222
}


ol,
ul {
  list-style: none;
  margin: 0 0 25px 0;
  padding: 0
}

.form-group {
  position: relative
}

.form-group.terms {
  padding: 12px 0 0 0
}

.form-group i {
  font-size: 18px;
  font-size: 1.125rem;
  position: absolute;
  right: 5px;
  top: 11px;
  color: #ccc;
  width: 25px;
  height: 25px;
  display: block;
  font-weight: 400 !important
}

.radio_input .error {
  left: -15px;
  top: -30px;
  right: inherit
}

.form-control {
  border: 1px solid #d2d8dd;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  border-radius: 3px;
  font-size: 14px;
  font-size: .875rem;
  height: calc(2.55rem + 2px)
}

.form-control:focus {
  box-shadow: none;
  border-color: #ae71ff
}

/*

.container_radio {
  display: block;
  position: relative;
  font-size: 14px;
  font-size: .875rem;
  padding-left: 30px;
  line-height: 1.3;
  margin-bottom: 10px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none
}

.container_radio input {
  position: absolute;
  opacity: 0
}

.container_radio input:checked~.checkmark:after {
  opacity: 1
}

.container_radio .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%
}

.container_radio .checkmark:after {
  display: block;
  content: "";
  position: absolute;
  opacity: 0;
  -moz-transition: all .3s ease-in-out;
  -o-transition: all .3s ease-in-out;
  -webkit-transition: all .3s ease-in-out;
  -ms-transition: all .3s ease-in-out;
  transition: all .3s ease-in-out;
  top: 3px;
  left: 3px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ae71ff;
  -moz-transition: all .3s ease-in-out;
  -o-transition: all .3s ease-in-out;
  -webkit-transition: all .3s ease-in-out;
  -ms-transition: all .3s ease-in-out;
  transition: all .3s ease-in-out
}
.container_radio.version_2 {
  padding: 6px 0 0 45px;
  min-height: 30px
}

.container_radio.version_2 input:checked~.checkmark:before {
  opacity: 1
}

.container_radio.version_2 .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 30px;
  width: 30px;
  border: 1px solid #ccc;
  border-radius: 50%
}

.container_radio.version_2 .checkmark:after {
  width: 30px;
  height: 30px;
  top: -1px;
  left: -1px
}

.container_radio.version_2 .checkmark:before {
  display: block;
  content: "";
  position: absolute;
  opacity: 0;
  -moz-transition: all .3s ease-in-out;
  -o-transition: all .3s ease-in-out;
  -webkit-transition: all .3s ease-in-out;
  -ms-transition: all .3s ease-in-out;
  transition: all .3s ease-in-out;
  left: 12px;
  top: 8px;
  width: 5px;
  height: 10px;
  border: solid #fff;
  z-index: 999;
  border-width: 0 2px 2px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg)
}
*/

.step {
  border: 1px solid #e5e7eb;
  background-color: #fff;
  padding: 24px;
  border-radius: 14px;
  margin-top: 16px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: relative;
}

.step .count {
  position: absolute;
  top: -12px;
  left: 16px;
  background: #ae71ff;
  padding: 4px 12px;
  border-radius: 20px;
  color: white;
  font-weight: 600;
  font-size: 13px;
  line-height: 1.4;
  white-space: nowrap;
  z-index: 1;
}

.main_question {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: #222;
}

.main_question.has-media {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.main_question .question-image {
  flex-shrink: 0;
  width: 200px;
  max-height: 200px;
  object-fit: contain;
  border-radius: 10px;
}

.main_question .question-text {
  flex: 1;
  min-width: 0;
}

.exam-buttons {
  margin-top: 16px;
  text-align: center;
  display: flex;
  justify-content: center;
  gap: 8px;
}

.exam-buttons .btn {
  min-height: 48px;
  min-width: 120px;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 500;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.exam-buttons .btn:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.exam-submit-spinner {
  display: inline-block;
  animation: spin 1s linear infinite;
  margin-right: 8px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Timer — inside step card, right-aligned */
.exam-timer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-bottom: 12px;
}

.exam-timer i {
  font-size: 16px;
  color: var(--primaryColor, #ae71ff);
  position: static;
  width: auto;
  height: auto;
  display: inline;
  line-height: 1;
}

.pre-answer-info {
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 12px;
}

.pre-answer-info .alert {
  margin-bottom: 0;
  padding: 8px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  border-radius: 8px;
  line-height: 1.4;
}

.pre-answer-info i {
  margin-right: 8px;
  font-size: 16px;
}

.completed-exam-alert {
  background: #eef6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  color: #1e40af;
}

.completed-exam-alert p {
  margin: 0;
}

/* ===== Mobile Responsive ===== */
@media (max-width: 767px) {
  .exam-timer i {
    font-size: 14px;
  }

  .exam-question-list {
    padding: 16px !important;
  }

  .step {
    padding: 16px;
    border-radius: 14px;
    margin-bottom: 16px;
  }

  .step .count {
    font-size: 12px;
    padding: 3px 10px;
    top: -10px;
    left: 12px;
  }

  .main_question {
    font-size: 16px;
    line-height: 1.5;
  }

  .main_question.has-media {
    flex-direction: column;
    gap: 12px;
  }

  .main_question .question-image {
    width: 100%;
    max-height: 160px;
  }

  .exam-buttons {
    margin-top: 16px;
    flex-wrap: wrap;
  }

  .exam-buttons .btn {
    flex: 1;
    min-width: 0;
    min-height: 48px;
    padding: 12px 16px;
    font-size: 15px;
    border-radius: 12px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  .exam-buttons .btn:hover {
    transform: none;
  }

  .exam-buttons .btn:active {
    transform: scale(0.98);
    opacity: 0.85;
  }

  .exam-result h4 {
    font-size: 15px;
  }

  .form-group i {
    position: static;
    width: auto;
    height: auto;
    display: inline;
  }
}

@media (max-width: 479px) {
  .exam-question-list {
    padding: 12px !important;
  }

  .step {
    padding: 12px;
  }

  .step .count {
    left: 10px;
    top: -10px;
  }

  .exam-buttons .btn {
    font-size: 14px;
    padding: 10px 12px;
  }
}
</style>

<style>
.slide-fade-enter-active {
  transition: all 0.1s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(80px);
  opacity: 0;
}

li {
  display: list-item;
  text-align: -webkit-match-parent;
}

ul {
  list-style-type: disc;
}

ol {
  display: block;
  list-style-type: decimal;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 40px;
}

.uk-modal-body {
  padding: 1rem;
}



/* Soru metni v-html içindeki p tag'leri — boşluk azalt */
.main_question p,
.main_question div p {
  margin: 0 0 4px 0;
  padding: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: #222;
}

.main_question p:last-child,
.main_question div p:last-child {
  margin-bottom: 0;
}

.main_question div {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: #222;
}

img.image-preview {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  width: auto;
  max-width: 100%;
  border-radius: 10px;
  background-color: #fff;
  padding: 4px;
  display: block;
  object-fit: contain;
}

/* Soru içindeki görsel — scoped'da kontrol ediliyor */

.container_radio {
  border: 1px solid #e5e7eb;
  padding: 12px 16px;
  transition: background-color 0.2s ease;
  cursor: pointer;
  border-radius: 10px;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
  gap: 6px;
}

.container_radio input {
  margin: 4px 0 0 0;
  flex-shrink: 0;
}

.container_radio:hover {
  background-color: #f9fafb;
}

.container_radio.answer--readonly {
  cursor: default;
}

.container_radio.answer--selected {
  border-width: 2px;
}

.container_radio.answer--correct {
  border-color: #22c55e;
  background-color: #f0fdf4;
}

.container_radio.answer--wrong {
  border-color: #ef4444;
  background-color: #fef2f2;
}

.answer-status {
  flex-shrink: 0;
  align-self: center;
  border-radius: 999px;
  padding: 3px 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
}

.answer--correct .answer-status {
  background: #dcfce7;
  color: #166534;
}

.answer--wrong .answer-status {
  background: #fee2e2;
  color: #991b1b;
}

/* Seçenek görseli — soru görselinden küçük */
.container_radio img.image-preview {
  width: 100px;
  max-width: 100px;
  max-height: 80px;
  flex-shrink: 0;
  margin: 0;
  border-radius: 8px;
  padding: 2px;
  object-fit: contain;
}

.option-text {
  flex: 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.5;
  color: #333;
  word-break: break-word;
}

/* Mobil seçenek layout */
@media (max-width: 767px) {
  .option-text {
    font-size: 16px;
  }
  .container_radio {
    flex-wrap: wrap;
    padding: 12px;
    min-height: 48px;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  .container_radio:hover {
    background-color: transparent;
  }

  .container_radio:active {
    background-color: #f3f4f6;
  }

  /* Mobil: seçenek görseli — soru görselinden belirgin küçük */
  .container_radio img.image-preview {
    width: 100%;
    max-width: 100%;
    max-height: 120px;
    order: -1;
    border-radius: 10px;
    object-fit: contain;
  }

}
</style>
